var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PreviewSingle page"},[(_vm.mailIndentifier && _vm.dentistUuid)?_c('div',[_c('Preview',{attrs:{"mailIndentifier":_vm.mailIndentifier,"dentistUuid":_vm.dentistUuid}})],1):_c('div',[_vm._v(" kein Zugriff ")])])}
var staticRenderFns = []

export { render, staticRenderFns }